import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { cn } from '@/common/utils/cn'
import { CreateGovernmentAllocationEntryModal } from '@/features/governmentAllocations/components/CreateGovernmentAllocationReinforcementModal'
import { useGovernmentAllocationEntries } from '@/features/governmentAllocations/hooks/useGovernmentAllocationEntries'
import { governmentAllocationDocumentsTableColumns } from '@/features/governmentAllocations/pages/Show/constants/governmentAllocationDocumentsTableColumns'
import { GovernmentAllocationDocumentsTransformer } from '@/features/governmentAllocations/services/governmentAllocationDocumentsTransformer'
import { GovernmentAllocationData } from '@/features/governmentAllocations/types/governmentAllocation.type'

type GovernmentAllocationDocumentsProps = {
  governmentAllocation: GovernmentAllocationData
  showReinforcementButton: boolean
  disableReinforcement: boolean
}

export const GovernmentAllocationDocuments = ({
  governmentAllocation,
  showReinforcementButton,
  disableReinforcement,
}: GovernmentAllocationDocumentsProps) => {
  const { filterParams, setFilterParams } = useFilterParams()

  const {
    data: governmentAllocationEntries,
    isLoading: governmentAllocationEntriesIsLoading,
    meta,
  } = useGovernmentAllocationEntries({
    governmentAllocationId: governmentAllocation.id,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: GovernmentAllocationDocumentsTransformer.tableTransformer(),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      {showReinforcementButton && (
        <div className="self-end">
          <CreateGovernmentAllocationEntryModal
            governmentAllocationId={governmentAllocation.id}
            disabled={disableReinforcement}
          />
        </div>
      )}

      <Table
        className={cn(
          'min-h-[256px]',
          governmentAllocation.controlled_by === 'quantity' ? 'max-h-[calc(100vh-432px)]' : 'max-h-[calc(100vh-496px)]',
        )}
        columns={governmentAllocationDocumentsTableColumns}
        rows={governmentAllocationEntries}
        hasPagination
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalCount={meta.total}
        totalPages={meta.total_pages}
        isLoadingData={governmentAllocationEntriesIsLoading}
        rowEmptyValue="--"
        loadingRows={2}
      />
    </div>
  )
}
